export default __webpack_public_path__ + "static/freight-forwarding-automation-67e7b7a3e3da14a7c0469e081dc1b8d4.png";